/* eslint-disable prettier/prettier */
import ArrowDown1 from './arrow-down-1.svg'
import ArrowLeft1 from './arrow-left-1.svg'
import ArrowRight1 from './arrow-right-1.svg'
import ArrowUp1 from './arrow-up-1.svg'
import Check from './check.svg'
import CircleAssinaturas from './circle-assinaturas.svg'
import CircleBpo from './circle-bpo.svg'
import CircleCondominios from './circle-condominios.svg'
import CircleEducacional from './circle-educacional.svg'
import CircleImobiliarias from './circle-imobiliarias.svg'
import CircleNext from './circle-next.svg'
import CirclePjbank from './circle-pjbank.svg'
import CircleXperience from './circle-xperience.svg'
import Condominios from './condominios.svg'
import Envelope from './envelope.svg'
import MessagesBubbleSquareQuotation from './messages-bubble-square-quotation.svg'
import PeopleMan1 from './people-man-1.svg'
import Phone from './phone.svg'
import RealEstateBuildingHouse from './real-estate-building-house.svg'
import RealEstateMarketBuildingRise from './real-estate-market-building-rise.svg'
import RealEstateMessagePersonBuilding1 from './real-estate-message-person-building-1.svg'
import SingleNeutralCircle from './single-neutral-circle.svg'
import SuperlogicaColor from './superlogica-color.svg'
import Superlogica from './superlogica.svg'

export default {
  'arrow-down-1': ArrowDown1,
  'arrow-left-1': ArrowLeft1,
  'arrow-right-1': ArrowRight1,
  'arrow-up-1': ArrowUp1,
  'check': Check,
  'circle-assinaturas': CircleAssinaturas,
  'circle-bpo': CircleBpo,
  'circle-condominios': CircleCondominios,
  'circle-educacional': CircleEducacional,
  'circle-imobiliarias': CircleImobiliarias,
  'circle-next': CircleNext,
  'circle-pjbank': CirclePjbank,
  'circle-xperience': CircleXperience,
  'condominios': Condominios,
  'envelope': Envelope,
  'messages-bubble-square-quotation': MessagesBubbleSquareQuotation,
  'people-man-1': PeopleMan1,
  'phone': Phone,
  'real-estate-building-house': RealEstateBuildingHouse,
  'real-estate-market-building-rise': RealEstateMarketBuildingRise,
  'real-estate-message-person-building-1': RealEstateMessagePersonBuilding1,
  'single-neutral-circle': SingleNeutralCircle,
  'superlogica-color': SuperlogicaColor,
  'superlogica': Superlogica,
}